import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import Main from './components/forms/Main';
import { GlobalClasses } from './styles/global';
import { store } from './redux';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';

export const muiCache = createCache({
  key: 'mui',
  prepend: true,
});

const root = createRoot(document.getElementById('provisioning'));

export const initApp = () => {
  root.render(
    <Provider store={store}>
      <CacheProvider value={muiCache}>
        <GlobalClasses />
        <Main />
      </CacheProvider>
    </Provider>
  );
};

initApp();